export default __webpack_public_path__ + "static/media/ic_seychelles.10834b42.svg";